import { IActionContext } from '@msdyn365-commerce/core';
import { IPredefinedRefinerHandler } from '../predefined-refiners';
import { getHandler as getConceptHandler } from './concept';

export default function getHandlers(context: IActionContext): IPredefinedRefinerHandler[] {
    return [
        getConceptHandler(context)
    ].filter(Boolean) as IPredefinedRefinerHandler[];
}
